export default {
  /*token在cookie的储存天数 默认1天*/
  cookieExpires: 1,
  //token的名字
  TOKEN_NAME: "hqtoken",
  //接口请求超时时间
  timeout: 5 * 1000,
  //版本号
  version: 400,
  cookieDoMain: process.env.NODE_ENV === "production" ? ".helloufu.com" : "",
  baseUrl: "https://data.helloufu.com",
  depotId: "13" //库管模块id
};
